<script>
  import {getContext} from 'svelte';

  export let style = '';
  const toggleDrawer = getContext('toggleDrawer');
</script>


<button on:click={toggleDrawer} style="{style}">
  <slot>
    <ion-icon name="menu-outline"></ion-icon>
  </slot>
</button>

<style>
  button {
    width: 56px;
    height: 56px;
    background: none;
    border: none;
  }

  ion-icon {
    font-size: 32px;
  }
</style>